import { createReducer } from "reduxsauce";
import Actions from "modules/entity-repository/entity-repository-actions";

const onEntityRepositoryHasChanged = (state, { repository }) => {
  const subRepository = Object.keys(repository)[0];
  if (!subRepository) {
    console.warn("No repository specified.");
    return state;
  }
  // We don't want to update specified entities, rather replace them.
  return {
    ...state,
    [subRepository]: {
      ...state[subRepository],
      ...repository[subRepository]
    }
  };
};

const INITIAL_STATE = {
  diagnostics: {},
  questions: {},
  diagnosticSessions: {}
};

const HANDLERS = {
  [Actions.Types.ENTITY_REPOSITORY_HAS_CHANGED]: onEntityRepositoryHasChanged
};

export default createReducer(INITIAL_STATE, HANDLERS);



// WEBPACK FOOTER //
// ./src/modules/entity-repository/entity-repository-reducer.js